import { injectable } from 'inversify-props';

export interface IScrollService {

	scrollToTop(): void;
	scrollToId(id: string): void;

}

@injectable()
export class ScrollService {

	public scrollToTop(): void {
		window.scroll({ top: 0, left: 0, behavior: 'smooth' });
	}

	public scrollToId(id: string): void {
		document.querySelector('.hello').scrollIntoView({
			behavior: 'smooth',
		});
	}

}
